import { Placement } from "@floating-ui/react-dom";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import Icon from "../Icon";
import Popover from "../Popover";

const sizes: Record<InfoIconSize, number> = {
  xs: 12,
  sm: 14,
  md: 18,
  lg: 28,
};

export type InfoIconSize = "xs" | "sm" | "md" | "lg";

export type InfoIconVariant = "primary" | "neutral";

export interface InfoIconProps extends PropsWithChildren {
  inverted?: boolean;
  placement?: Placement;
  size?: InfoIconSize;
  variant?: InfoIconVariant;
  label?: string;
}

const InfoIcon: FC<InfoIconProps> = ({
  placement,
  children,
  inverted,
  size = "md",
  variant = "primary",
  label,
}) => {
  const iconSize = sizes[size];

  return (
    <Popover
      placement={placement}
      content={children}
      trigger="hover"
      variant="white"
    >
      <span
        className={clsx(
          "cursor-pointer -m-2xs -ml-2xs p-2xs flex focus-visible:ring-2 focus-visible:ring-primary-800 focus:outline-none rounded-s relative",
          {
            "text-neutral-0": inverted,
            "text-primary-800 hover:text-primary-825":
              !inverted && variant === "primary",
            "text-neutral-150 hover:text-primary-800":
              !inverted && variant === "neutral",
          },
        )}
      >
        {label && <span className="sr-only">{label}</span>}
        <Icon size={iconSize} type="Info" />
      </span>
    </Popover>
  );
};

export default InfoIcon;
